import { useId } from 'react';

const StarColoredGreenLightIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const uid = useId();
  const id = `paint0_linear_2095_5448_${uid}`;

  return (
    <svg {...props} viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        data-figma-bg-blur-radius="157.511"
        d="M8.8025 0.829883L10.4208 4.09404C10.5425 4.33988 10.7775 4.50989 11.05 4.54906L14.7858 5.08902C15.4708 5.18818 15.7442 6.0282 15.2483 6.50987L12.5475 9.13071C12.35 9.32238 12.26 9.5982 12.3066 9.86904L12.9241 13.4557C13.0491 14.1832 12.285 14.7382 11.63 14.3957L8.39 12.6999C8.14667 12.5724 7.85664 12.5724 7.61414 12.6999L4.37663 14.394C3.7208 14.7374 2.95411 14.1815 3.07994 13.4524L3.69752 9.86904C3.74418 9.5982 3.65413 9.32238 3.45663 9.13071L0.755825 6.50987C0.259158 6.0282 0.532434 5.18818 1.21827 5.08902L4.95413 4.54906C5.22579 4.50989 5.4608 4.33988 5.5833 4.09404L7.20165 0.829883C7.52748 0.167383 8.47416 0.167383 8.8025 0.829883Z"
        fill={`url(#${id})`}
      />
      <defs>
        <clipPath id="bgblur_0_2095_5448_clip_path" transform="translate(157.009 157.178)">
          <path d="M8.8025 0.829883L10.4208 4.09404C10.5425 4.33988 10.7775 4.50989 11.05 4.54906L14.7858 5.08902C15.4708 5.18818 15.7442 6.0282 15.2483 6.50987L12.5475 9.13071C12.35 9.32238 12.26 9.5982 12.3066 9.86904L12.9241 13.4557C13.0491 14.1832 12.285 14.7382 11.63 14.3957L8.39 12.6999C8.14667 12.5724 7.85664 12.5724 7.61414 12.6999L4.37663 14.394C3.7208 14.7374 2.95411 14.1815 3.07994 13.4524L3.69752 9.86904C3.74418 9.5982 3.65413 9.32238 3.45663 9.13071L0.755825 6.50987C0.259158 6.0282 0.532434 5.18818 1.21827 5.08902L4.95413 4.54906C5.22579 4.50989 5.4608 4.33988 5.5833 4.09404L7.20165 0.829883C7.52748 0.167383 8.47416 0.167383 8.8025 0.829883Z" />
        </clipPath>
        <linearGradient
          id={id}
          x1="8.00177"
          y1="0.333008"
          x2="8.00177"
          y2="14.4995"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#95FF58" />
          <stop offset="1" stopColor="#D6FFC0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default StarColoredGreenLightIcon;
